import React from "react";
import { Link } from "react-router-dom";
import Icon from "../../../../components/base/Icon";
import { RecentJobItem } from "../../models/AdminDashboardModel";

type Props = {
    items?: RecentJobItem[]
}

function RecentJobsWidget(props: Props) {
    const items = props.items ?? [];
    return (
        <div className="card border-0 shadow-sm h-100">
            <div className="card-header border-0 pt-5 d-flex align-items-center">
                <div className="flex-grow-1">
                    <h3 className="widget-title">Recent Jobs</h3>
                    <div className="widget-subtitle">Last {items.length} job{items.length === 1 ? "" : "s"}</div>
                </div>
                <Link to="/crm/jobs/all" className="btn btn-sm btn-light-primary">View all</Link>
            </div>
            <div className="card-body pt-3 p-0">
                {items.length === 0 && (
                    <div className="text-center text-gray-500 py-8">
                        <Icon icon="briefcase" type="thin" size={48} className="text-gray-400 mb-3" />
                        <div>No recent jobs</div>
                    </div>
                )}
                <div className="table-responsive">
                    {items.length > 0 && (
                        <table className="table table-row-bordered align-middle gy-3 mb-0">
                            <thead>
                                <tr className="text-gray-500 fw-bold fs-8 text-uppercase">
                                    <th className="ps-6">Job</th>
                                    <th>Customer</th>
                                    <th className="d-none d-md-table-cell">Type</th>
                                    <th className="d-none d-lg-table-cell">Tech</th>
                                    <th>Status</th>
                                    <th className="d-none d-md-table-cell">Created</th>
                                </tr>
                            </thead>
                            <tbody>
                                {items.map(j => (
                                    <tr key={j.id} style={{ cursor: "pointer" }}>
                                        <td className="ps-6">
                                            <Link to={`/crm/jobs/details/${j.id}`} className="text-gray-900 fw-bold">#{j.jobId}</Link>
                                        </td>
                                        <td className="text-gray-700">{j.fullName || "—"}</td>
                                        <td className="text-gray-600 fs-7 d-none d-md-table-cell">{j.jobType || "—"}</td>
                                        <td className="text-gray-600 fs-7 d-none d-lg-table-cell">{j.techName || "—"}</td>
                                        <td>
                                            {j.statusName && (
                                                <span className="badge" style={{
                                                    background: (j.statusColor || "#A1A5B7") + "22",
                                                    color: j.statusColor || "#A1A5B7",
                                                    fontWeight: 600,
                                                    fontSize: "0.7rem"
                                                }}>
                                                    {j.statusName}
                                                </span>
                                            )}
                                        </td>
                                        <td className="text-gray-500 fs-8 d-none d-md-table-cell">{j.createdAtText}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
}

export default RecentJobsWidget;
